"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAccessToken = void 0;
var apis_1 = require("./apis");
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var eventListener_1 = require("./utils/eventListener");
var APP_ENV;
var TIER;
var intervalId;
var login = function (configs, apiParams, loginRetries, appUI) {
    if (appUI === void 0) { appUI = constants_1.APP_UI.DEFAULT; }
    return __awaiter(void 0, void 0, void 0, function () {
        var maxRetryLimit, code, _a, userId, userGroupId, atToken, expiryTime, error_1, retries;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    maxRetryLimit = 2;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 9]);
                    console.log('ERROR debug: in login:', appUI);
                    return [4, (0, apis_1.getV2LoginCode)(constants_1.CONFIG_HIVER, configs, apiParams, appUI)];
                case 2:
                    code = _b.sent();
                    return [4, (0, apis_1.getLoginToken)(code, constants_1.CONFIG_HIVER, configs)];
                case 3:
                    _a = _b.sent(), userId = _a.userId, userGroupId = _a.userGroupId, atToken = _a.atToken, expiryTime = _a.expiryTime;
                    (0, utils_1.setTokenAndExpiry)(atToken, expiryTime);
                    (0, utils_1.setUserDetails)(userId, userGroupId);
                    return [3, 9];
                case 4:
                    error_1 = _b.sent();
                    console.log('ERROR debug: in error login:', error_1, appUI);
                    retries = loginRetries;
                    _b.label = 5;
                case 5:
                    if (!(retries < maxRetryLimit)) return [3, 8];
                    return [4, login(configs, apiParams, retries + 1, appUI)];
                case 6:
                    _b.sent();
                    _b.label = 7;
                case 7:
                    retries++;
                    return [3, 5];
                case 8: throw error_1;
                case 9: return [2];
            }
        });
    });
};
var retryPostConflict = function (conflictRetryDelay, totalConflictRetryDelay, tokenFetchConfigs) { return __awaiter(void 0, void 0, void 0, function () {
    var retryDelay, configs, apiParams, appUI;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(totalConflictRetryDelay < constants_1.MAX_CONFLICT_RETRY_DELAY)) return [3, 3];
                return [4, new Promise(function (resolve) { return setTimeout(resolve, conflictRetryDelay); })];
            case 1:
                _a.sent();
                totalConflictRetryDelay += conflictRetryDelay;
                if (conflictRetryDelay * 2 <= constants_1.MAX_BACKOFF_LIMIT) {
                    conflictRetryDelay *= 2;
                }
                else {
                    conflictRetryDelay = constants_1.MAX_BACKOFF_LIMIT;
                }
                console.log('Heimdall: Fetch token post doubling conflict retry delay', conflictRetryDelay);
                retryDelay = tokenFetchConfigs.retryDelay, configs = tokenFetchConfigs.configs, apiParams = tokenFetchConfigs.apiParams, appUI = tokenFetchConfigs.appUI;
                return [4, fetchAndSaveToken(retryDelay, conflictRetryDelay, totalConflictRetryDelay, configs, apiParams, appUI)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [2];
        }
    });
}); };
var fetchAndSaveToken = function (retryDelay, conflictRetryDelay, totalConflictRetryDelay, configs, apiParams, origin, appUI) {
    if (origin === void 0) { origin = 'default'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var _a, atToken, expiryTime, userId, userGroupId, error_2, loginRetries, tokenFetchConfigs;
        var _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _h.trys.push([0, 2, , 12]);
                    console.log('Heimdall: Interval Set on fetch token in fetchAndSaveToken:', intervalId);
                    return [4, (0, apis_1.getAccessToken)(constants_1.CONFIG_HIVER, configs, apiParams, origin)];
                case 1:
                    _a = _h.sent(), atToken = _a.atToken, expiryTime = _a.expiryTime, userId = _a.userId, userGroupId = _a.userGroupId;
                    atToken && expiryTime && (0, utils_1.setTokenAndExpiry)(atToken, expiryTime);
                    userId && userGroupId && (0, utils_1.setUserDetails)(userId, userGroupId);
                    retryDelay = constants_1.INITIAL_RETRY_DELAY;
                    conflictRetryDelay = constants_1.INITIAL_RETRY_DELAY;
                    totalConflictRetryDelay = 0;
                    return [3, 12];
                case 2:
                    error_2 = _h.sent();
                    console.log('ERROR: Heimdall fetch token', error_2);
                    if (!(((_b = error_2.response) === null || _b === void 0 ? void 0 : _b.status) === 401 || ((_c = error_2.request) === null || _c === void 0 ? void 0 : _c.status) === 401)) return [3, 4];
                    loginRetries = 1;
                    return [4, login(configs, apiParams, loginRetries, appUI)];
                case 3:
                    _h.sent();
                    return [3, 11];
                case 4:
                    if (!(((_d = error_2.response) === null || _d === void 0 ? void 0 : _d.status) === 409 || ((_e = error_2.request) === null || _e === void 0 ? void 0 : _e.status) === 409)) return [3, 6];
                    console.log('Heimdall: Fetching token post 409 in fetch And Save Token');
                    tokenFetchConfigs = { retryDelay: retryDelay, configs: configs, apiParams: apiParams, appUI: appUI };
                    return [4, retryPostConflict(conflictRetryDelay, totalConflictRetryDelay, tokenFetchConfigs)];
                case 5:
                    _h.sent();
                    if (totalConflictRetryDelay >= constants_1.MAX_CONFLICT_RETRY_DELAY) {
                        throw error_2;
                    }
                    return [3, 11];
                case 6:
                    if (!(((_f = error_2.response) === null || _f === void 0 ? void 0 : _f.status) === 422 || ((_g = error_2.request) === null || _g === void 0 ? void 0 : _g.status) === 422)) return [3, 7];
                    console.log('ERROR: Throwing error', error_2.response.status);
                    throw error_2;
                case 7:
                    if (!(retryDelay <= constants_1.MAX_RETRY_DELAY)) return [3, 10];
                    return [4, new Promise(function (resolve) { return setTimeout(resolve, retryDelay); })];
                case 8:
                    _h.sent();
                    retryDelay *= 2;
                    console.log('Heimdall: Fetch token post doubling retry delay', retryDelay);
                    return [4, fetchAndSaveToken(retryDelay, conflictRetryDelay, totalConflictRetryDelay, configs, apiParams, appUI)];
                case 9:
                    _h.sent();
                    return [3, 11];
                case 10: throw error_2;
                case 11: return [3, 12];
                case 12: return [2];
            }
        });
    });
};
var checkAndRefetchToken = function (configs, apiParams, retryDelay, conflictRetryDelay, totalConflictRetryDelay, appUI) {
    if (retryDelay === void 0) { retryDelay = constants_1.INITIAL_RETRY_DELAY; }
    if (conflictRetryDelay === void 0) { conflictRetryDelay = constants_1.INITIAL_RETRY_DELAY; }
    if (totalConflictRetryDelay === void 0) { totalConflictRetryDelay = 0; }
    return __awaiter(void 0, void 0, void 0, function () {
        var refetchToken, randomDelay, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    refetchToken = (0, utils_1.isTokenInExpiryWindow)();
                    if (!refetchToken) return [3, 3];
                    randomDelay = (0, utils_1.getRandomDelay)();
                    return [4, (0, utils_1.introduceDelay)(randomDelay)];
                case 1:
                    _a.sent();
                    console.log('Heimdall: Fetching token - in expiry window');
                    return [4, fetchAndSaveToken(retryDelay, conflictRetryDelay, totalConflictRetryDelay, configs, apiParams, appUI)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [3, 5];
                case 4:
                    error_3 = _a.sent();
                    throw error_3;
                case 5: return [2];
            }
        });
    });
};
var fetchAccessToken = function (appEnv, tier, apiParams, isHiverApiDomain, origin, appUI) { return __awaiter(void 0, void 0, void 0, function () {
    var retryDelay, conflictRetryDelay, totalConflictRetryDelay, configs, callback, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                APP_ENV = appEnv;
                TIER = tier;
                retryDelay = constants_1.INITIAL_RETRY_DELAY;
                conflictRetryDelay = constants_1.INITIAL_RETRY_DELAY;
                totalConflictRetryDelay = 0;
                configs = (0, utils_1.getConfig)(APP_ENV, TIER, isHiverApiDomain);
                console.log('Instance: Fetch Call');
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4, fetchAndSaveToken(retryDelay, conflictRetryDelay, totalConflictRetryDelay, configs, apiParams, origin, appUI)];
            case 2:
                _a.sent();
                console.log('Heimdall: Interval Set on fetch token when fetch token is called:', intervalId);
                clearInterval(intervalId);
                intervalId = setInterval(function () { return checkAndRefetchToken(configs, apiParams); }, constants_1.REFETCH_CHECK_DELAY);
                callback = function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, checkAndRefetchToken(configs, apiParams)];
                            case 1:
                                _a.sent();
                                return [2];
                        }
                    });
                }); };
                console.log('Heimdall: Interval Set on fetch token:', intervalId);
                (0, eventListener_1.subscribeToOnlineEvent)(callback);
                return [3, 4];
            case 3:
                error_4 = _a.sent();
                console.log('ERROR: Fetching token failed', error_4);
                return [3, 4];
            case 4: return [2];
        }
    });
}); };
exports.fetchAccessToken = fetchAccessToken;
//# sourceMappingURL=fetchAccessToken.js.map